import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-86a3756c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alarm-monitor-real"
};
const _hoisted_2 = {
  class: "top-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "top-container"
};
const _hoisted_5 = {
  class: "search-left"
};
import { reactive, watch, ref, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { runtimePage } from "@/api/deviceManage";
import { weChatrequest } from '@/utils/request';
import { useStore } from "vuex";
const __default__ = {
  name: "alarm-monitor-real"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const store = useStore();
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    const route = useRoute();
    const state = reactive({
      split: 0.13,
      defaultProps: {
        label: "name",
        children: "children"
      },
      treeData: [],
      defaultCheckNode: [],
      defaultExendNode: [],
      currentNodeKey: '',
      tableData: {
        rows: [],
        total: 0
      }
    });
    let queryParams = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      actNum: "",
      valveName: "",
      areaId: ''
    });
    const searchFormData = ref([{
      prop: "valveName",
      label: "阀井名称",
      placeholder: "请输入阀井名称",
      type: "text",
      span: 4
    },
    // {
    //   prop: "wellNum",
    //   label: "阀井编号",
    //   placeholder: "请输入阀井编号",
    //   type: "text",
    //   span:4
    // },
    {
      prop: "actNum",
      label: "执行器编号",
      placeholder: "请输入执行器编号",
      type: "text",
      span: 4
    }]);
    let loading = ref(false);
    const getList = () => {
      loading.value = true;
      runtimePage(queryParams).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const resetQuery = () => {
      queryParams.actNum = '';
      queryParams.valveName = '';
      queryParams.pageNum = 1;
      getList();
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      class: "btn-liquid",
      icon: "el-icon-search",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader = [{
      prop: "valveName",
      label: "阀井名称",
      fixed: false,
      type: "text"
    }, {
      prop: "actNum",
      label: "设备编号",
      fixed: false,
      type: "text"
    }, {
      prop: "location",
      label: "设备位置",
      fixed: false,
      type: "text"
    }, {
      prop: "alarmTime",
      label: "告警时间",
      fixed: false,
      type: "text"
    }, {
      prop: "alarmDesc",
      label: "告警描述",
      fixed: false,
      type: "text"
    }];
    const handleNodeClick = params => {
      nextTick(() => {
        state.defaultCheckNode = [params];
      });
      queryParams.areaId = params.id;
      state.currentNodeKey = params.id;
      getList();
    };
    onMounted(async () => {
      state.loading = true;
      weChatrequest({
        url: '/api/v1/sysArea/findTree',
        method: "get"
      }).then(res => {
        state.treeData = [res.data];
        if (state.treeData[0]?.children) {
          state.defaultExendNode = state.treeData[0].children[0].id;
        }
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    });
    return (_ctx, _cache) => {
      const _component_treeSelect = _resolveComponent("treeSelect");
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_splitPane = _resolveComponent("splitPane");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(userType) == 3 ? (_openBlock(), _createBlock(_component_splitPane, {
        key: 0,
        value: state.split,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => state.split = $event)
      }, {
        leftContent: _withCtx(() => [_withDirectives(_createVNode(_component_treeSelect, {
          ref: "tree",
          title: "地区树",
          onHandleNodeClick: handleNodeClick,
          defaultExpand: false,
          data: state.treeData,
          "default-props": state.defaultProps,
          defaultExendNode: state.defaultExendNode,
          defaultCheckNode: state.defaultCheckNode,
          nodeKey: "id",
          currentNodeKey: _ctx.currentNodeKey
        }, null, 8, ["data", "default-props", "defaultExendNode", "defaultCheckNode", "currentNodeKey"]), [[_directive_loading, state.loading]])]),
        rightContent: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
          form: _unref(queryParams),
          formData: searchFormData.value,
          showLabel: true,
          formHandle: formHandle
        }, null, 8, ["form", "formData"])])]), _withDirectives(_createVNode(_component_commonTable, {
          size: "medium",
          ref: "tableContainer",
          style: {
            "clear": "both"
          },
          hasStripe: false,
          hasSelect: false,
          tableData: state.tableData,
          multipleSelection: state.multipleSelection,
          "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
          tableHeader: tableHeader,
          queryParams: _unref(queryParams),
          onGetList: getList
        }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])]),
        _: 1
      }, 8, ["value"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasStripe: false,
        hasSelect: false,
        tableData: state.tableData,
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[2] || (_cache[2] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])], 64))]);
    };
  }
});